import { PROGRESS_STAGES } from '../constants/formOptions';

export function GeneratingProgress({ progress, darkMode=false, t }) {
  const dm = darkMode;
  const stage = [...PROGRESS_STAGES].reverse().find(s => progress >= s.at) || PROGRESS_STAGES[0];
  const clampedProgress = Math.min(progress, 99);
  const desc = t?.generatingDesc || (dm ? "잠시만 기다려주세요" : "잠시만 기다려주세요");

  const TIPS = [
    { emoji:"🌅", title:"출발 전날 꿀팁", sub:"여권·지갑·충전기는 전날 밤 가방에 미리 챙겨두세요. 아침 당황을 줄일 수 있어요!", bg:"linear-gradient(135deg,#667eea,#764ba2)" },
    { emoji:"🗺️", title:"오프라인 지도 준비", sub:"여행지 지도를 미리 오프라인으로 저장해두면 데이터 없이도 길을 찾을 수 있어요.", bg:"linear-gradient(135deg,#f093fb,#f5576c)" },
    { emoji:"🍽️", title:"현지 식당 고르는 법", sub:"현지인이 줄 서서 먹는 곳이 진짜 맛집! 관광지 중심부보다 골목 안쪽을 노려보세요.", bg:"linear-gradient(135deg,#43e97b,#38f9d7)" },
    { emoji:"💰", title:"환전 꿀팁", sub:"공항 환전소보다 시내 은행이나 ATM이 수수료가 낮은 경우가 많아요.", bg:"linear-gradient(135deg,#4facfe,#00f2fe)" },
    { emoji:"🎒", title:"짐 가볍게 싸기", sub:"입을 옷의 절반만 챙기세요. 여행지에서 사는 즐거움도 여행의 일부예요!", bg:"linear-gradient(135deg,#fa709a,#fee140)" },
    { emoji:"📱", title:"로밍 vs 유심", sub:"1주일 이상 여행이라면 현지 유심이 경제적일 수 있어요. 공항 도착 전 미리 알아보세요.", bg:"linear-gradient(135deg,#a18cd1,#fbc2eb)" },
    { emoji:"🏨", title:"숙소 선택 팁", sub:"위치가 전부예요. 조금 비싸더라도 교통 요지의 숙소가 이동 비용·시간을 아껴줘요.", bg:"linear-gradient(135deg,#ffecd2,#fcb69f)" },
    { emoji:"🌤️", title:"날씨 대비 필수템", sub:"우산보다 가벼운 우비가 여행엔 훨씬 실용적이에요. 폴더블 우비 하나 챙겨보세요!", bg:"linear-gradient(135deg,#a1c4fd,#c2e9fb)" },
  ];
  const tipIdx = Math.floor((clampedProgress / 15) % TIPS.length);
  const tip = TIPS[tipIdx];

  return (
    <div style={{ textAlign:"center", padding:"44px 0 36px" }}>
      {/* 여행 꿀팁 카드 */}
      <div style={{ margin:"0 auto 28px", width:"100%", maxWidth:320 }}>
        <div style={{ borderRadius:16, overflow:"hidden", boxShadow:"0 8px 32px rgba(0,0,0,0.18)", position:"relative", transition:"all 0.6s ease" }}>
          <div style={{ background:tip.bg, padding:"22px 20px 18px", color:"#fff", textAlign:"left" }}>
            <div style={{ position:"absolute", top:10, right:12, fontSize:9, fontWeight:800, background:"rgba(255,255,255,0.25)", padding:"2px 7px", borderRadius:20, letterSpacing:"0.1em" }}>TIP</div>
            <div style={{ fontSize:36, marginBottom:8 }}>{tip.emoji}</div>
            <div style={{ fontSize:15, fontWeight:900, marginBottom:4, lineHeight:1.3 }}>{tip.title}</div>
            <div style={{ fontSize:11, opacity:0.88, lineHeight:1.6 }}>{tip.sub}</div>
          </div>
        </div>
        <div style={{ marginTop:8, fontSize:10, color:dm?"rgba(226,232,240,0.35)":"rgba(51,65,85,0.35)", textAlign:"right" }}>여행 꿀팁</div>
      </div>

      {/* Stage label */}
      <div style={{ marginBottom:20 }}>
        <div style={{ fontSize:22, marginBottom:8 }}>{stage.icon}</div>
        <p style={{ color:"var(--accent)", fontWeight:700, fontSize:15, marginBottom:4, }}>{stage.label}</p>
        <p style={{ color:dm?"rgba(226,232,240,0.65)":"rgba(71,85,105,0.70)", fontSize:12 }}>{desc}</p>
      </div>

      {/* Progress bar */}
      <div style={{ margin:"0 8px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
          <span style={{ fontSize:11, color:"rgba(51,65,85,0.68)", fontWeight:600 }}>생성률</span>
          <span style={{ fontSize:12, color:"var(--accent)", fontWeight:900 }}>{clampedProgress}%</span>
        </div>
        <div style={{ height:8, background:dm?"rgba(129,140,248,0.08)":"rgba(99,102,241,0.1)", borderRadius:99, overflow:"hidden" }}>
          <div style={{
            height:"100%", borderRadius:99,
            background:`linear-gradient(90deg, var(--accent), var(--teal))`,
            width:`${clampedProgress}%`,
            transition:"width 0.4s ease",
            boxShadow:"0 0 12px rgba(129,140,248,0.5)"
          }}/>
        </div>
        {/* Stage dots */}
        <div style={{ display:"flex", justifyContent:"space-between", marginTop:10 }}>
          {PROGRESS_STAGES.map((s, i) => {
            const done = progress >= s.at;
            return (
              <div key={i} title={s.label} style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
                <div style={{ width:8, height:8, borderRadius:"50%", background: done ? "var(--accent)" : dm?"rgba(129,140,248,0.12)":"rgba(99,102,241,0.12)", transition:"background 0.3s", boxShadow: done ? dm?"0 0 10px rgba(129,140,248,0.5)":"0 0 8px rgba(99,102,241,0.35)" : "none" }}/>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
